import type { FeatureFlags } from "@/types"

/**
 * THE feature-flag read. One missing-flag default for every gate mechanism:
 * DENY. The backend serves every key of the generated FeatureFlags type
 * (flags:sync pins both directions), so a key that is absent from a present
 * payload means an older backend that cannot run the feature — hiding it is
 * the only honest answer. Callers that must not block while auth is still
 * hydrating should gate on the user object being loaded, not on a permissive
 * flag default (see FeatureGuard).
 */
export function hasFlag(
  flags: FeatureFlags | undefined | null,
  key: keyof FeatureFlags
): boolean {
  return flags?.[key] === true
}
